var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"view-loading"},[_c('v-progress-circular',{attrs:{"color":"primary","indeterminate":""}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }